// ライブラリ
// import polyfill from './inc/polyfill.js';

// ポリフィル
// polyfill();

// 関数群
import EnvDetector from './inc/EnvDetector.js';
// import webFont from './inc/webFont.js';
// import ScrollManager from './inc/ScrollManager.js';
import touchDevice from './inc/touchDevice.js';
// import mainVisual from './inc/mainVisual.js';
// import swiperjs from './inc/swiper.js';
import CustomPropertyManager from './inc/customPropertyManager.js';
// import MenuManager from './inc/MenuManager.js';
// import hideOnScroll from './inc/HideOnScroll.js';

// IEを判定してbodyタグにclass付与
new EnvDetector();

// Web Font Loader
// TODO: 不要か判断して削除する
// webFont();

// Scroll Magicによるスクロール管理
// new ScrollManager();

// タッチデバイス対応（ホバー挙動の再現など）
touchDevice();

// メインビジュアル動画
// mainVisual();

// swiperjs();

// CSSのカスタムプロパティを管理
new CustomPropertyManager();

// メニュー管理（ハンバーガーメニュー、モーダル）
// new MenuManager();

// // 要素をスクロール時に隠す
// new hideOnScroll();
